import type { NextPage } from 'next/types';
import NextErrorPage from 'next/error';
import Bugsnag from 'helpers/bugsnag';

type ErrorPageType = {
  statusCode: number;
};

const CustomErrorPage: NextPage<ErrorPageType> = ({ statusCode }) => {
  return <NextErrorPage statusCode={statusCode} />;
};

CustomErrorPage.getInitialProps = (ctx) => {
  if (ctx.err) Bugsnag.notify(ctx.err);
  return NextErrorPage.getInitialProps(ctx);
};

export default CustomErrorPage;
